import React, { useContext } from "react";
import { AppContext } from "../../App";
import favicon from "/images/favicon.png";

import { RefreshCcw } from "lucide-react";

import { Tooltip } from "antd";

import "./style.css";
import { toast } from "sonner";

export const Header = () => {
  const { setIsRefreshStreaming } = useContext(AppContext);

  return (
    <div className="header">
      <span style={{ fontSize: 13, fontWeight: 500 }}>Version 13.05.03</span>
      <img style={{ width: 41 }} alt="MedArmor" src={favicon} />
      <div className="header-setting">
        <span
          onClick={() => {
            setIsRefreshStreaming(true);
            toast.success("Cập nhật lại streaming thành công");
          }}
        >
          <Tooltip title="Cập nhật lại streaming">
            <RefreshCcw
              size={20}
              style={{ color: "#fff", cursor: "pointer" }}
            />
          </Tooltip>
        </span>
      </div>
    </div>
  );
};
